import { useState } from 'react'

export function TestComponent() {
  const [count, setCount] = useState(0)

  return (
    <div className="p-8 bg-white rounded-lg shadow-lg max-w-md mx-auto mt-10">
      <h2 className="text-2xl font-bold mb-4 text-gray-800">
        Тестовый компонент
      </h2>
      <p className="mb-4 text-gray-600">
        Счётчик: <span className="text-blue-600 font-bold">{count}</span>
      </p>
      <button
        onClick={() => setCount(count + 1)}
        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
      >
        Увеличить
      </button>
    </div>
  )
}
